
export default [
  {
    'name' : '🏆(대상) 아두이노 자동주차 시스템',
    'info' : 'Ardino + C 언어',
    'disc' : '아두이노와 RC카를 결합하고, 자동으로 주차 공간을 찾아 주차하는 알고리즘 적용.',
    'date' : '2018.07',
    'link' : 'https://github.com/ini080/Arduino_AutoParking',
  },
  {
    'name' : '스마트 블라인드',
    'info' : 'Ardino + C 언어',
    'disc' : '밝기에 따라 자동으로 블라인드가 조절되어 온도를 유지해줍니다',
    'date' : '2018.11',
    'link' : 'https://github.com/ini080/Arduino_SmartBlind',
  },
  {
    'name' : 'Safe_Food Project',
    'info' : 'Java + JSP + Springboot + MySQL + Mybatis + Vue.js',
    'disc' : '안전한 먹거리를 제공하는 프로젝트입니다.',
    'text' : 'MVC(Model - View - Controller) 모델 사용 , 회원관리, 회원별 알레르기에 맞는 음식추천',
    'date' : '2019.05',
    'link' : 'https://github.com/ini080/Safe_Food',
  },
  {
    'name' : '다솜봇 카카오톡 챗봇',
    'info' : 'Node JS + API + KAKAO I OpenBuilder + Firebase + AWS EC2',
    'disc' : '광주 버스 남은시간, 전국 날씨, 한<->영 번역 등 여러 API를 합쳐 만든 자동응답 챗봇.',
    'date' : '2019.07',
    'link' : 'https://github.com/ini080/chatbot'
  },
  {
    'name' : 'WebMobile Project',
    'info' : 'Java + Springboot + Firebase + Vue.js + AWS',
    'disc' : 'Vue로 만든 웹과 모바일 둘다 호응되는 반응형 웹사이트',
    'text' : 'Back-End & Front-End, 회원관리, 회원별 권한 설정 글 or 댓글 작성',
    'date' : '2019.08',
    'link' : 'https://github.com/ini080/web-Mobile-Final',
  },
  {
    'name' : '🏆(대상) AI 뉴스 챗봇',
    'info' : 'Python + Flask + MySQL + Vue.js + AWS',
    'disc' : '뉴스기사를 파싱하여 기사내용,댓글을 분석하여 나타내줍니다.',
    'text' : 'MachineLearning을 통해 15만건 이상의 단어를 학습하여 댓글의 긍정/부정, 지역감정 여부 등을 판별해 나타냅니다.',
    'date' : '2019.10',
    'link' : 'https://github.com/ini080/AI_Chatbot',
  },
]
